"use strict";
exports.__esModule = true;
var stat_1 = require("~/js/lib/stat/stat");
var iStat = new stat_1.Stat({
    prodid: 'yylive',
    param: {
        sys: '4',
        report_type: 0,
        sid: ''
    }
});
var iType = window.location.pathname.split('/')[1];
var eventid = 20014315;
var webtype = 'yy.com';
switch (iType) {
    case 'shenqu':
        eventid = 20014355;
        webtype = 'shenqu';
        break;
    case 'bbs':
        eventid = 20014353;
        webtype = 'bbs';
        break;
    case 'yue':
        eventid = 20014351;
        webtype = 'yyue';
        break;
    default:
        break;
}
var EStatType;
(function (EStatType) {
    EStatType["GUILD_CLICK"] = "guildClick";
    EStatType["ANCHOR_CLICK"] = "anchorClick";
    EStatType["LOGO_CLICK"] = "logoClick";
    EStatType["BACK_CLICK"] = "backClick";
    EStatType["NAV_TITLE_CLICK"] = "navTitleClick";
    EStatType["NAV_ITEM_CLICK"] = "navItemClick";
    EStatType["SEARCH_HISTORY_CLEAR"] = "searchHistoryClear";
    EStatType["SEARCH_HISTORY_ITEM_CLICK"] = "searchHistoryItemClick";
    EStatType["SEARCH_RECOMMEND_ITEM_CLICK"] = "searchRecommendItemClick";
    EStatType["SEARCH_CHANNEL_BOX_ITEM_CLICK"] = "searchChannelBoxItemClick";
    EStatType["SEARCH_SORT_BOX_ITEM_CLICK"] = "searchSortBoxItemClick";
    EStatType["SEARCH_CONNECT_BOX_ITEM_CLICK"] = "searchConnectBoxClick";
    EStatType["SEARCH_LIVE_BTN_CLICK"] = "searchLiveBtnClick";
    EStatType["SEARCH_KEYWORD"] = "searchKeyword";
    EStatType["SEARCH_INPUT_CHANGE"] = "searchInputChange";
    EStatType["DOWNLOAD_ITEM_CLICK"] = "downloadItemClick";
    EStatType["FOLLOW_ANCHOR_ITEM_CLICK"] = "followAnchorItemClick";
    EStatType["FOLLOW_CHANNEL_ITEM_CLICK"] = "followChannelItemClick";
    EStatType["USERINFO_RECHARGE_CLICK"] = "userinfoRechargeClick";
    EStatType["USERINFO_GET_MONEY_CLICK"] = "userinfoGetMoneyClick";
    EStatType["USERINFO_AVATAR_CLICK"] = "userinfoAvatarClick";
    EStatType["USERINFO_DAILY_TASK_SIGN_CLICK"] = "userinfoDailyTaskSignClick";
    EStatType["USERINFO_DAILY_TASK_OPEN_TASK_CENTER_CLICK"] = "userinfoDailyTaskOpenTaskCenterClick";
    EStatType["HISTORY_ITEM_CLICK"] = "historyItemClick";
    EStatType["UDB_READY"] = "udbReady";
    EStatType["UDB_QR_CLICK"] = "udbQrClick";
    EStatType["UDB_SCAN_SUCCESS"] = "udbScanSuccess";
    EStatType["UDB_QR_LOGIN_SUCCESS"] = "udbQrLoginSuccess";
    EStatType["UDB_REG_TAG_CLICK"] = "udbRegTagClick";
    EStatType["UDB_REG_SUCCESS"] = "udbRegSuccess";
    EStatType["UDB_QQ_LOGIN_CLICK"] = "udbQqLoginClick";
    EStatType["UDB_WB_LOGIN_CLICK"] = "udbWbLoginClick";
    EStatType["UDB_WX_LOGIN_CLICK"] = "udbWxLoginClick";
    EStatType["UDB_LOGIN_SUCCESS"] = "udbLoginSuccess";
    EStatType["UDB_LOGIN_BTN_CLICK"] = "udbLoginBtnClick";
    EStatType["UDB_REG_REPORT"] = "udbRegReport";
})(EStatType = exports.EStatType || (exports.EStatType = {}));
function statSend(op) {
    iStat.emit(op);
}
exports.statSend = statSend;
function stat(type, argu) {
    if (argu === void 0) { argu = []; }
    function sendIt(acttype, moreinfo) {
        iStat.emit({
            eventid: eventid,
            act_type: acttype,
            more_info: Object.assign({
                web_type: webtype
            }, moreinfo)
        });
    }
    var iActtype;
    switch (type) {
        case EStatType.GUILD_CLICK:
            iStat.emit({ eventid: '20042757', act_type: '15' });
            break;
        case EStatType.ANCHOR_CLICK:
            iStat.emit({ eventid: '20042757', act_type: '16' });
            break;
        case EStatType.LOGO_CLICK:
            sendIt('4001');
            break;
        case EStatType.BACK_CLICK:
            sendIt('1001');
            break;
        case EStatType.NAV_TITLE_CLICK:
            sendIt('1002');
            break;
        case EStatType.NAV_TITLE_CLICK:
            sendIt('1003');
            switch (argu[0]) {
                case '游戏':
                    sendIt('1005');
                    break;
                case '娱乐':
                    sendIt('1004');
                    break;
                case '其他':
                    sendIt('1006');
                    break;
            }
            break;
        case EStatType.SEARCH_HISTORY_CLEAR:
            iStat.emit({
                eventid: '20018027',
                act_type: ' 1202'
            });
            break;
        case EStatType.SEARCH_HISTORY_ITEM_CLICK:
            sendIt('7002');
            iStat.emit({
                eventid: '20018027',
                act_type: '1201'
            });
            break;
        case EStatType.SEARCH_RECOMMEND_ITEM_CLICK:
            iStat.emit({
                eventid: '20018027',
                act_type: '1301'
            });
            break;
        case EStatType.SEARCH_CHANNEL_BOX_ITEM_CLICK:
            iStat.emit({
                eventid: '20018027',
                act_type: '1301'
            });
            iStat.emit({
                eventid: '20018027',
                act_type: '1401'
            });
            iStat.emit({
                eventid: '20021657',
                act_type: '101',
                more_info: {
                    enter_content: argu[0]
                }
            });
            break;
        case EStatType.SEARCH_SORT_BOX_ITEM_CLICK:
            iStat.emit({
                eventid: '20018027',
                act_type: '1402'
            });
            iStat.emit({
                eventid: '20021657',
                act_type: '101',
                more_info: {
                    enter_content: argu[0]
                }
            });
            break;
        case EStatType.SEARCH_CONNECT_BOX_ITEM_CLICK:
            iStat.emit({
                eventid: '20018027',
                act_type: '1403'
            });
            break;
        case EStatType.SEARCH_LIVE_BTN_CLICK:
            iStat.emit({
                eventid: '20018027',
                act_type: '1404'
            });
            break;
        case EStatType.SEARCH_KEYWORD:
            iStat.emit({
                eventid: '20021657',
                act_type: '101',
                more_info: {
                    enter_content: argu[0]
                }
            });
            iStat.emit({
                eventid: '20018027',
                act_type: argu[0] ? '1103' : '1101'
            });
            sendIt('5001', { module: '3' });
            break;
        case EStatType.SEARCH_INPUT_CHANGE:
            iStat.emit({
                eventid: '20018027',
                act_type: '1102',
                more_info: {
                    enter_content: argu[0]
                }
            });
            break;
        case EStatType.DOWNLOAD_ITEM_CLICK:
            sendIt('2001');
            switch (argu[0]) {
                case 'pc':
                    sendIt('2003');
                    break;
                case 'soft':
                    sendIt('2004');
                    break;
                case 'mobileYY':
                    sendIt('2002');
                    break;
            }
            break;
        case EStatType.FOLLOW_ANCHOR_ITEM_CLICK:
            sendIt('7003');
            sendIt('7001');
            break;
        case EStatType.FOLLOW_CHANNEL_ITEM_CLICK:
            sendIt('7004');
            sendIt('7001');
            break;
        case EStatType.HISTORY_ITEM_CLICK:
            sendIt('7002');
            break;
        case EStatType.USERINFO_AVATAR_CLICK:
            sendIt('8003');
            break;
        case EStatType.USERINFO_GET_MONEY_CLICK:
            sendIt('8002');
            break;
        case EStatType.USERINFO_RECHARGE_CLICK:
            sendIt('8001');
            break;
        case EStatType.USERINFO_DAILY_TASK_SIGN_CLICK:
            iStat.emit({ eventid: '20025119', act_type: '4001' });
            break;
        case EStatType.USERINFO_DAILY_TASK_OPEN_TASK_CENTER_CLICK:
            iStat.emit({ eventid: '20025119', act_type: '2003' });
            break;
        case EStatType.UDB_QR_CLICK:
            sendIt('10001');
            break;
        case EStatType.UDB_SCAN_SUCCESS:
            sendIt('10002');
            break;
        case EStatType.UDB_QR_LOGIN_SUCCESS:
            sendIt('10003');
            break;
        case EStatType.UDB_REG_SUCCESS:
            sendIt('', { module: '10' });
            break;
        case EStatType.UDB_QQ_LOGIN_CLICK:
            sendIt('', { module: '9', moduleid: '1' });
            break;
        case EStatType.UDB_WB_LOGIN_CLICK:
            sendIt('', { module: '9', moduleid: '2' });
            break;
        case EStatType.UDB_WX_LOGIN_CLICK:
            sendIt('', { module: '9', moduleid: '3' });
            break;
        case EStatType.UDB_LOGIN_SUCCESS:
            sendIt('', { module: '9', moduleid: '0' });
            break;
        case EStatType.UDB_REG_REPORT:
            iStat.emit({ eventid: '20025119', act_type: '4004' });
            break;
    }
}
exports.stat = stat;
var EMetricsType;
(function (EMetricsType) {
    EMetricsType["USERCAR_FETCH_USER_INFO"] = "userCardFetchUserInfo";
    EMetricsType["USERCAR_FETCH_USER_INFO_BY_REVENUE"] = "userCardFetchUserInfoByRevenue";
    EMetricsType["USERCAR_DAILY_TASK_SIGNIN"] = "userCardDailyTaskSignin";
    EMetricsType["USERCAR_DAILY_TASK"] = "userCardDailyTask";
    EMetricsType["USERCAR_GOLD"] = "userCardGold";
    EMetricsType["LOGIN_AUTH"] = "loginAuth";
    EMetricsType["FOLLOW"] = "follow";
})(EMetricsType = exports.EMetricsType || (exports.EMetricsType = {}));
function metrics(type, param) {
    var uriArr = [];
    switch (type) {
        case EMetricsType.USERCAR_FETCH_USER_INFO:
            uriArr = ['用户信息卡', '获取用户信息', webtype];
            break;
        case EMetricsType.USERCAR_FETCH_USER_INFO_BY_REVENUE:
            uriArr = ['用户信息卡', '获取用户营收信息', webtype];
            break;
        case EMetricsType.USERCAR_DAILY_TASK_SIGNIN:
            uriArr = ['用户信息卡', '签到操作', webtype];
            break;
        case EMetricsType.USERCAR_DAILY_TASK:
            uriArr = ['用户信息卡', '获取每日任务信息', webtype];
            break;
        case EMetricsType.USERCAR_GOLD:
            uriArr = ['用户信息卡', '获取金币数量', webtype];
            break;
        case EMetricsType.LOGIN_AUTH:
            uriArr = ['用户登录', '获取Auth', webtype];
            break;
        case EMetricsType.FOLLOW:
            uriArr = ['其他', '关注操作', webtype];
            break;
    }
    if (uriArr.length) {
        iStat.metrics('service', {
            scode: 50208,
            ver: '1.0.0',
            uri: uriArr.join('/'),
            timeSpent: param.cost,
            code: param.code
        });
    }
}
exports.metrics = metrics;
